(function () {
  const sharedState = window.BakerRaeCakeRequestFormState || {};
  sharedState.initializedForms = sharedState.initializedForms || new WeakSet();
  window.BakerRaeCakeRequestFormState = sharedState;

  const initializedForms = sharedState.initializedForms;
  const formControlSelector = 'input, select, textarea';
  const bakerraeTimeZone = 'America/Toronto';
  const scheduleLeadTimeMs = 100 * 60 * 60 * 1000;
  const pickupTimeStartMinutes = 12 * 60;
  const pickupTimeEndMinutes = 16 * 60;
  const pickupTimeStepMinutes = 30;

  function initCakeRequestForm(root) {
    if (!root || initializedForms.has(root)) return;

    initializedForms.add(root);

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-occasion-select], [data-occasion-control]')) {
        setOccasionState(root);
      }

      if (event.target.matches('[data-fulfillment-control]')) {
        setFulfillmentState(root);
        setDateConstraints(root);
        validateDateOrder(root);
      }

      if (event.target.matches('[data-cake-category], [data-cake-category-control]')) {
        if (root.dataset.cakeSelectorJustExpanded === 'true') {
          updateProgressiveState(root);
          scheduleProgressiveUpdate(root);
          return;
        }

        delete root.dataset.cakeSelectorExpanded;
        setCakeCategoryState(root);
      }

      if (event.target.matches('[data-fulfillment-date]')) {
        setDateConstraints(root);
        validateDateOrder(root);
      }

      if (event.target.matches('[data-phone-number]')) {
        normalizePhoneNumber(event.target);
      }

      if (event.target.matches(formControlSelector)) {
        markControlTouched(event.target);
        updateControlValidationMessage(root, event.target, true);
      }

      updateProgressiveState(root);
      scheduleProgressiveUpdate(root);
    });

    root.addEventListener('input', function (event) {
      if (!event.target.matches(formControlSelector)) return;

      if (event.target.matches('[data-fulfillment-date]')) {
        setDateConstraints(root);
        validateDateOrder(root);
      }

      updateControlValidationMessage(root, event.target, false);
      updateProgressiveState(root);
      scheduleProgressiveUpdate(root);
    });

    root.addEventListener('click', function (event) {
      if (event.target.closest('.cake-request-form__occasion-card')) {
        window.setTimeout(function () {
          setOccasionState(root);
        }, 0);
      }

      const cakeOptionCard = event.target.closest('.cake-request-form__cake-option-card');
      if (cakeOptionCard) {
        if (root.dataset.cakeSelectorJustExpanded === 'true') {
          event.preventDefault();
          return;
        }

        const grid = root.querySelector('[data-cake-option-grid]');
        const control = cakeOptionCard.querySelector('[data-cake-category-control]');
        const shouldExpand = grid && grid.classList.contains('is-collapsed') && control && control.checked;

        if (shouldExpand) {
          event.preventDefault();
          root.dataset.cakeSelectorExpanded = 'true';
          root.dataset.cakeSelectorJustExpanded = 'true';
          setCakeSelectorCollapsed(root, false);
          updateProgressiveState(root);
          scheduleProgressiveUpdate(root);
          control.focus();

          window.setTimeout(function () {
            delete root.dataset.cakeSelectorJustExpanded;
          }, 0);

          return;
        }

        window.setTimeout(function () {
          delete root.dataset.cakeSelectorExpanded;
          setCakeCategoryState(root);
        }, 0);
      }

      if (event.target.closest('[data-cake-change]')) {
        event.preventDefault();
        root.dataset.cakeSelectorExpanded = 'true';
        setCakeSelectorCollapsed(root, false);
        scheduleProgressiveUpdate(root);

        const checkedControl = root.querySelector('[data-cake-category-control]:checked');
        if (checkedControl) {
          checkedControl.focus();
        }
      }
    });

    root.addEventListener(
      'blur',
      function (event) {
        if (event.target.matches('[data-postal-code]')) {
          normalizeCanadianPostalCode(event.target);
        }

        if (event.target.matches('[data-phone-number]')) {
          normalizePhoneNumber(event.target);
        }

        if (event.target.matches(formControlSelector)) {
          markControlTouched(event.target);
          updateControlValidationMessage(root, event.target, true);
          updateProgressiveState(root);
          scheduleProgressiveUpdate(root);
        }
      },
      true
    );

    const form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', function (event) {
        setOccasionState(root);
        setFulfillmentState(root);
        setCakeCategoryState(root);
        setDateConstraints(root);
        normalizePhoneNumbers(root);
        updateProgressiveState(root);

        const datesAreValid = validateDateOrder(root);
        const visibleFieldsAreValid = showVisibleValidationMessages(root);
        if (!datesAreValid || !visibleFieldsAreValid || !form.reportValidity()) {
          event.preventDefault();
        }
      });
    }

    setOccasionState(root);
    setFulfillmentState(root);
    setCakeCategoryState(root);
    syncWeddingOccasionState(root);
    setDateConstraints(root);
    validateDateOrder(root);
    updateProgressiveState(root);

    window.setTimeout(function () {
      setOccasionState(root);
      updateProgressiveState(root);
      scheduleProgressiveUpdate(root);
    }, 0);
  }

  function scheduleProgressiveUpdate(root) {
    if (!root || root.dataset.progressiveUpdateQueued === 'true') return;

    root.dataset.progressiveUpdateQueued = 'true';

    window.requestAnimationFrame(function () {
      delete root.dataset.progressiveUpdateQueued;
      updateProgressiveState(root);
    });
  }

  function setOccasionState(root) {
    const select = root.querySelector('[data-occasion-select]');
    const checkedControl = root.querySelector('[data-occasion-control]:checked');
    const group = root.querySelector('[data-other-occasion-group]');

    if (!group) return;

    const occasionValue = checkedControl ? checkedControl.value : select ? select.value : '';
    setConditionalGroup(group, occasionValue === 'Other', occasionValue !== 'Other');
  }

  function setFulfillmentState(root) {
    const selectedValue = getFulfillmentValue(root);
    const pickupLocation = root.querySelector('[data-pickup-location]');
    const deliveryFields = root.querySelector('[data-delivery-fields]');
    const scheduleFields = root.querySelector('[data-schedule-fields]');
    const scheduleLegend = root.querySelector('[data-schedule-legend]');
    const scheduleDateLabel = root.querySelector('[data-fulfillment-date-label-text]');
    const scheduleTimeLabel = root.querySelector('[data-fulfillment-time-label-text]');
    const deliveryCostNote = root.querySelector('[data-delivery-cost-note]');

    if (pickupLocation) {
      pickupLocation.disabled = selectedValue !== 'Pickup';
      if (selectedValue === 'Pickup' && pickupLocation.dataset.staticValue !== undefined) {
        pickupLocation.value = pickupLocation.dataset.staticValue;
      }
    }

    setConditionalGroup(deliveryFields, selectedValue === 'Delivery', selectedValue !== 'Delivery');
    setConditionalGroup(scheduleFields, Boolean(selectedValue), !selectedValue);

    if (scheduleLegend) {
      if (selectedValue === 'Pickup') {
        scheduleLegend.textContent = 'Pickup date and time';
      } else if (selectedValue === 'Delivery') {
        scheduleLegend.textContent = 'Delivery date and time';
      } else {
        scheduleLegend.textContent = 'Requested pickup or delivery date and time';
      }
    }

    if (scheduleDateLabel) {
      if (selectedValue === 'Pickup') {
        scheduleDateLabel.textContent = 'Pickup date';
      } else if (selectedValue === 'Delivery') {
        scheduleDateLabel.textContent = 'Delivery date';
      } else {
        scheduleDateLabel.textContent = 'Requested date';
      }
    }

    if (scheduleTimeLabel) {
      if (selectedValue === 'Pickup') {
        scheduleTimeLabel.textContent = 'Pickup time';
      } else if (selectedValue === 'Delivery') {
        scheduleTimeLabel.textContent = 'Delivery time';
      } else {
        scheduleTimeLabel.textContent = 'Requested time';
      }
    }

    if (deliveryCostNote) {
      deliveryCostNote.hidden = selectedValue !== 'Delivery';
    }
  }

  function setCakeCategoryState(root, options) {
    const checkedControl = root.querySelector('[data-cake-category-control]:checked');
    const select = root.querySelector('[data-cake-category]');
    const panels = root.querySelectorAll('[data-cake-panel]');
    const selectedOption = select ? select.options[select.selectedIndex] : null;
    const selectedPanelId = checkedControl
      ? checkedControl.dataset.panelId
      : selectedOption
        ? selectedOption.dataset.panelId
        : '';
    const selectedValue = checkedControl ? checkedControl.value : selectedOption ? selectedOption.value : '';
    const previousPanelId = root.dataset.activeCakePanel || '';
    const shouldClearPrevious = !options || options.clearPrevious !== false;

    panels.forEach(function (panel) {
      const isActive = panel.dataset.cakePanel === selectedPanelId;
      const shouldClear = shouldClearPrevious && !isActive && panel.dataset.cakePanel === previousPanelId;
      setConditionalGroup(panel, isActive, shouldClear);
    });

    root.dataset.activeCakePanel = selectedPanelId || '';
    setCakeSelectorCollapsed(root, Boolean(selectedPanelId), selectedValue);
    syncWeddingOccasionState(root);
    updateProgressiveState(root);
  }

  function setCakeSelectorCollapsed(root, collapsed, selectedValue) {
    const grid = root.querySelector('[data-cake-option-grid]');
    const changeButton = root.querySelector('[data-cake-change]');
    const shouldCollapse = collapsed && root.dataset.cakeSelectorExpanded !== 'true';

    if (grid) {
      grid.hidden = false;
      grid.classList.toggle('is-collapsed', shouldCollapse);

      grid.querySelectorAll('[data-cake-category-control]').forEach(function (control) {
        const card = control.closest('.cake-request-form__cake-option-card');
        const isSelected = control.checked;

        if (!card) return;

        card.hidden = shouldCollapse && !isSelected;
        card.classList.toggle('cake-request-form__cake-option-card--selected', shouldCollapse && isSelected);
      });
    }

    if (changeButton) {
      changeButton.hidden = !shouldCollapse;
    }
  }

  function updateProgressiveState(root) {
    const cakeDetailsStep = getProgressiveStep(root, 'cake-details');
    const occasionStep = getProgressiveStep(root, 'occasion');
    const personalStep = getProgressiveStep(root, 'personal');
    const fulfillmentStep = getProgressiveStep(root, 'fulfillment');
    const deliveryStep = getProgressiveStep(root, 'delivery');
    const scheduleStep = getProgressiveStep(root, 'schedule');
    const optionalStep = getProgressiveStep(root, 'optional');
    const activeCakePanel = getActiveCakePanel(root);
    const hasCakeSelection = Boolean(activeCakePanel);
    const weddingCakeSelected = hasCakeSelection && isWeddingCakeSelected(root);

    syncWeddingOccasionState(root, weddingCakeSelected);

    setProgressiveStep(cakeDetailsStep, hasCakeSelection);

    const cakeDetailsComplete = hasCakeSelection && areRequiredControlsValid(activeCakePanel);
    setProgressiveStep(occasionStep, cakeDetailsComplete && !weddingCakeSelected);

    const occasionComplete = cakeDetailsComplete && (weddingCakeSelected || areRequiredControlsValid(occasionStep));
    setProgressiveStep(personalStep, occasionComplete);

    const personalComplete = occasionComplete && areRequiredControlsValid(personalStep);
    setProgressiveStep(fulfillmentStep, personalComplete);

    const fulfillmentValue = getFulfillmentValue(root);
    const fulfillmentComplete = personalComplete && Boolean(fulfillmentValue);
    const deliveryAvailable = fulfillmentComplete && fulfillmentValue === 'Delivery';

    setProgressiveStep(deliveryStep, deliveryAvailable);

    const deliveryComplete = deliveryAvailable && areRequiredControlsValid(deliveryStep);
    const scheduleAvailable =
      fulfillmentValue === 'Pickup' ? fulfillmentComplete : fulfillmentValue === 'Delivery' ? deliveryComplete : false;

    setProgressiveStep(scheduleStep, scheduleAvailable);

    const scheduleComplete = scheduleAvailable && areRequiredControlsValid(scheduleStep) && validateDateOrder(root);
    setProgressiveStep(optionalStep, scheduleComplete);
    syncValidationMessages(root);
  }

  function getProgressiveStep(root, name) {
    return root.querySelector('[data-progressive-step="' + name + '"]');
  }

  function getActiveCakePanel(root) {
    const selectedPanelId = root.dataset.activeCakePanel || '';

    if (!selectedPanelId) return null;

    return root.querySelector('[data-cake-panel="' + selectedPanelId + '"]');
  }

  function isWeddingCakeSelected(root) {
    const activeCakePanel = getActiveCakePanel(root);
    return Boolean(activeCakePanel && activeCakePanel.dataset.cakePanelType === 'wedding_cake');
  }

  function syncWeddingOccasionState(root, active) {
    if (!root) return;

    const weddingOccasion = root.querySelector('[data-wedding-occasion-value]');
    if (!weddingOccasion) return;

    const shouldUseWeddingOccasion = active !== undefined ? active : isWeddingCakeSelected(root);
    weddingOccasion.disabled = !shouldUseWeddingOccasion;

    if (shouldUseWeddingOccasion) {
      weddingOccasion.value = 'Wedding';
    }
  }

  function getFulfillmentValue(root) {
    const selected = root.querySelector('[data-fulfillment-control]:checked');
    if (selected) return selected.value;

    const staticControl = root.querySelector('[data-fulfillment-control][type="hidden"]');
    return staticControl && !staticControl.disabled ? staticControl.value : '';
  }

  function areRequiredControlsValid(container) {
    if (!container) return false;

    const requiredControls = Array.from(container.querySelectorAll('input, select, textarea')).filter(function (control) {
      return control.required && !control.matches(':disabled');
    });

    if (requiredControls.length === 0) return true;

    return requiredControls.every(function (control) {
      return control.checkValidity();
    });
  }

  function setProgressiveStep(group, active) {
    if (!group) return;

    const controls = group.querySelectorAll('input, select, textarea, button');

    if (active) {
      const wasHidden = group.hidden;

      group.hidden = false;

      if ('disabled' in group) {
        group.disabled = false;
      }

      controls.forEach(function (control) {
        if (control.dataset.progressiveDisabled === 'true') {
          control.disabled = false;
          delete control.dataset.progressiveDisabled;
        }
      });

      if (wasHidden) {
        group.dataset.progressiveVisible = 'false';
        window.requestAnimationFrame(function () {
          if (!group.hidden) {
            group.dataset.progressiveVisible = 'true';
          }
        });
      } else {
        group.dataset.progressiveVisible = 'true';
      }

      return;
    }

    group.dataset.progressiveVisible = 'false';

    if ('disabled' in group) {
      group.disabled = true;
    } else {
      controls.forEach(function (control) {
        if (!control.matches(':disabled')) {
          control.disabled = true;
          control.dataset.progressiveDisabled = 'true';
        }
      });
    }

    group.hidden = true;
    clearValidationMessages(group);
  }

  function setConditionalGroup(group, active, clearWhenDisabled) {
    if (!group) return;

    const controls = group.querySelectorAll('input, select, textarea');

    if (active) {
      group.hidden = false;
      if ('disabled' in group) {
        group.disabled = false;
      }

      controls.forEach(function (control) {
        control.disabled = false;

        if (control.dataset.staticValue !== undefined) {
          control.value = control.dataset.staticValue;
        }

        if (control.dataset.autoSelectWhenActive !== undefined && !control.checked) {
          control.checked = true;
        }

        if (control.hasAttribute('data-required-when-active')) {
          setRequired(control, true);
        }
      });

      return;
    }

    controls.forEach(function (control) {
      setRequired(control, false);
      resetControlValidation(control);
    });

    if (clearWhenDisabled) {
      clearControls(group);
    }

    controls.forEach(function (control) {
      control.disabled = true;
    });

    if ('disabled' in group) {
      group.disabled = true;
    }

    group.hidden = true;
  }

  function setRequired(control, required) {
    if (!control) return;

    if (required) {
      control.setAttribute('required', '');
      control.setAttribute('aria-required', 'true');
    } else {
      control.removeAttribute('required');
      control.removeAttribute('aria-required');
      control.setCustomValidity('');
      resetControlValidation(control);
    }
  }

  function clearControls(group) {
    if (!group) return;

    group.querySelectorAll('input, select, textarea').forEach(function (control) {
      resetControlValidation(control);

      if (control.type === 'radio' || control.type === 'checkbox') {
        control.checked = false;
        return;
      }

      if (control.tagName === 'SELECT') {
        control.selectedIndex = 0;
        return;
      }

      control.value = '';
    });
  }

  function markControlTouched(control) {
    if (!control || !isValidationCandidate(control)) return;

    getValidationGroup(control).forEach(function (groupControl) {
      groupControl.dataset.validationTouched = 'true';
    });
  }

  function syncValidationMessages(root) {
    if (!root) return;

    root.querySelectorAll(formControlSelector).forEach(function (control) {
      if (!isValidationCandidate(control)) {
        resetControlValidation(control);
        return;
      }

      updateControlValidationMessage(root, control, false);
    });
  }

  function showVisibleValidationMessages(root) {
    if (!root) return true;

    let allVisibleFieldsAreValid = true;
    const handledRadioGroups = [];

    root.querySelectorAll(formControlSelector).forEach(function (control) {
      if (!isValidationCandidate(control)) return;

      if (control.type === 'radio') {
        if (handledRadioGroups.indexOf(control.name) !== -1) return;
        handledRadioGroups.push(control.name);
      }

      markControlTouched(control);
      if (!updateControlValidationMessage(root, control, true)) {
        allVisibleFieldsAreValid = false;
      }
    });

    return allVisibleFieldsAreValid;
  }

  function updateControlValidationMessage(root, control, forceShow) {
    if (!root || !control) return true;

    const groupControls = getValidationGroup(control);
    const target = groupControls[0] || control;
    const touched = groupControls.some(function (groupControl) {
      return groupControl.dataset.validationTouched === 'true';
    });
    const isValid = target.checkValidity();

    if (isValid || (!forceShow && !touched)) {
      clearControlValidationMessage(target);
      return isValid;
    }

    showControlValidationMessage(root, target, getValidationMessage(target));
    return false;
  }

  function isValidationCandidate(control) {
    if (!control || !control.matches(formControlSelector)) return false;
    if (control.type === 'hidden' || control.disabled || control.matches(':disabled')) return false;
    if (!control.closest('[data-cake-request-form]')) return false;

    return isElementVisible(control);
  }

  function isElementVisible(element) {
    if (!element) return false;
    if (element.closest('[hidden]')) return false;

    return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function getValidationGroup(control) {
    if (!control || control.type !== 'radio' || !control.name) return control ? [control] : [];

    const root = control.closest('[data-cake-request-form]');
    if (!root) return [control];

    return Array.from(root.querySelectorAll('input[type="radio"]')).filter(function (groupControl) {
      return (
        groupControl.name === control.name &&
        groupControl.form === control.form &&
        !groupControl.disabled &&
        !groupControl.matches(':disabled') &&
        isElementVisible(groupControl)
      );
    });
  }

  function getValidationMessage(control) {
    if (!control) return 'Please check this field.';

    if (control.validity && control.validity.patternMismatch && control.title) {
      return control.title;
    }

    return control.validationMessage || 'Please check this field.';
  }

  function showControlValidationMessage(root, control, message) {
    const messageElement = getOrCreateValidationMessage(root, control);
    const groupControls = getValidationGroup(control);

    if (!messageElement) return;

    messageElement.textContent = message;
    messageElement.hidden = false;

    groupControls.forEach(function (groupControl) {
      groupControl.setAttribute('aria-invalid', 'true');
      groupControl.dataset.validationInvalid = 'true';
      addDescribedBy(groupControl, messageElement.id);
    });
  }

  function getOrCreateValidationMessage(root, control) {
    const messageId = getValidationMessageId(root, control);
    let messageElement = root.querySelector('#' + messageId);

    if (messageElement) return messageElement;

    const container = getValidationMessageContainer(control);
    if (!container) return null;

    messageElement = document.createElement('small');
    messageElement.id = messageId;
    messageElement.className = 'cake-request-form__field-error form__message';
    messageElement.setAttribute('role', 'alert');
    messageElement.setAttribute('data-validation-message', '');
    messageElement.hidden = true;
    container.appendChild(messageElement);

    return messageElement;
  }

  function getValidationMessageId(root, control) {
    if (control.id) return control.id + '-validation-error';

    const rootId = (root.dataset.sectionId || 'cake-request-form').replace(/[^A-Za-z0-9_-]/g, '-');
    const controlName = (control.name || 'field').replace(/[^A-Za-z0-9_-]/g, '-');
    return rootId + '-' + controlName + '-validation-error';
  }

  function getValidationMessageContainer(control) {
    if (!control) return null;

    if (control.type === 'radio') {
      return (
        control.closest('.cake-request-form__nested-fieldset') ||
        control.closest('.cake-request-form__fieldset') ||
        control.parentElement
      );
    }

    return control.closest('.cake-request-form__control') || control.parentElement;
  }

  function clearValidationMessages(container) {
    if (!container) return;

    container.querySelectorAll(formControlSelector).forEach(resetControlValidation);
    container.querySelectorAll('[data-validation-message]').forEach(function (messageElement) {
      messageElement.hidden = true;
      messageElement.textContent = '';
    });
  }

  function clearControlValidationMessage(control) {
    if (!control) return;

    const root = control.closest('[data-cake-request-form]');
    const groupControls = getValidationGroup(control);
    const target = groupControls[0] || control;
    const messageId = root ? getValidationMessageId(root, target) : '';
    const messageElement = messageId ? root.querySelector('#' + messageId) : null;

    if (messageElement) {
      messageElement.hidden = true;
      messageElement.textContent = '';
    }

    groupControls.forEach(function (groupControl) {
      removeDescribedBy(groupControl, messageId);

      if (groupControl.dataset.validationInvalid === 'true') {
        groupControl.removeAttribute('aria-invalid');
        delete groupControl.dataset.validationInvalid;
      }
    });
  }

  function resetControlValidation(control) {
    if (!control) return;

    clearControlValidationMessage(control);
    delete control.dataset.validationTouched;
  }

  function addDescribedBy(control, id) {
    if (!control || !id) return;

    const ids = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (ids.indexOf(id) === -1) {
      ids.push(id);
      control.setAttribute('aria-describedby', ids.join(' '));
    }
  }

  function removeDescribedBy(control, id) {
    if (!control || !id) return;

    const ids = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (item) {
      return item && item !== id;
    });

    if (ids.length > 0) {
      control.setAttribute('aria-describedby', ids.join(' '));
    } else {
      control.removeAttribute('aria-describedby');
    }
  }

  function setDateConstraints(root) {
    const today = getLocalDateString(new Date());
    const fulfillmentDate = root.querySelector('[data-fulfillment-date]');
    const fulfillmentValue = getFulfillmentValue(root);
    const minimumDate = hasScheduleLeadTime(fulfillmentValue) ? getScheduleMinimumDateString() : today;

    if (fulfillmentDate) {
      fulfillmentDate.min = minimumDate;
      fulfillmentDate.removeAttribute('max');

      if (fulfillmentDate.value && fulfillmentDate.value < minimumDate) {
        fulfillmentDate.value = '';
      }
    }

    setFulfillmentTimeConstraints(root);
  }

  function validateDateOrder(root) {
    const fulfillmentDate = root.querySelector('[data-fulfillment-date]');

    if (fulfillmentDate) {
      fulfillmentDate.setCustomValidity('');
    }

    return true;
  }

  function setFulfillmentTimeConstraints(root) {
    const fulfillmentTime = root.querySelector('[data-fulfillment-time]');
    const fulfillmentDate = root.querySelector('[data-fulfillment-date]');
    const fulfillmentValue = getFulfillmentValue(root);
    const scheduleCutoff = getScheduleCutoffDate();
    const scheduleCutoffDate = getBakerRaeDateString(scheduleCutoff);
    let minimumMinutes = pickupTimeStartMinutes;

    if (hasScheduleLeadTime(fulfillmentValue) && fulfillmentDate && fulfillmentDate.value === scheduleCutoffDate) {
      const cutoffMinutes = getBakerRaeMinutes(scheduleCutoff);
      minimumMinutes = Math.max(pickupTimeStartMinutes, Math.ceil(cutoffMinutes / pickupTimeStepMinutes) * pickupTimeStepMinutes);
    }

    if (!fulfillmentTime) return;

    Array.from(fulfillmentTime.options).forEach(function (option) {
      if (!option.value) return;

      const optionMinutes = getTimeOptionMinutes(option.value);
      const isValid =
        optionMinutes !== null &&
        optionMinutes >= minimumMinutes &&
        optionMinutes <= pickupTimeEndMinutes &&
        optionMinutes % pickupTimeStepMinutes === 0;

      option.disabled = !isValid;
      option.hidden = !isValid;
    });

    if (fulfillmentTime.selectedOptions.length > 0) {
      const selectedOption = fulfillmentTime.selectedOptions[0];
      if (selectedOption.disabled || selectedOption.hidden) {
        fulfillmentTime.value = '';
      }
    }
  }

  function getScheduleMinimumDateString() {
    const scheduleCutoff = getScheduleCutoffDate();
    const cutoffMinutes = getBakerRaeMinutes(scheduleCutoff);
    const minimumDate = getBakerRaeDateString(scheduleCutoff);

    if (cutoffMinutes > pickupTimeEndMinutes) {
      return addDaysToDateString(minimumDate, 1);
    }

    return minimumDate;
  }

  function getScheduleCutoffDate() {
    return new Date(Date.now() + scheduleLeadTimeMs);
  }

  function hasScheduleLeadTime(fulfillmentValue) {
    return fulfillmentValue === 'Pickup' || fulfillmentValue === 'Delivery';
  }

  function getBakerRaeDateParts(date) {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: bakerraeTimeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    });
    const parts = {};

    formatter.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') {
        parts[part.type] = part.value;
      }
    });

    return parts;
  }

  function getBakerRaeDateString(date) {
    const parts = getBakerRaeDateParts(date);

    return parts.year + '-' + parts.month + '-' + parts.day;
  }

  function getBakerRaeMinutes(date) {
    const parts = getBakerRaeDateParts(date);

    return Number(parts.hour) * 60 + Number(parts.minute);
  }

  function addDaysToDateString(dateString, days) {
    const parts = dateString.split('-').map(Number);
    const date = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));

    date.setUTCDate(date.getUTCDate() + days);

    return date.toISOString().slice(0, 10);
  }

  function getTimeOptionMinutes(value) {
    const match = /^(\d{1,2}):([0-5]\d)\s(AM|PM)\s-\s\d{1,2}:[0-5]\d\s[AP]M$/.exec(value);
    if (!match) return null;

    let hours = Number(match[1]);
    const minutes = Number(match[2]);
    const period = match[3];

    if (period === 'AM' && hours === 12) {
      hours = 0;
    } else if (period === 'PM' && hours !== 12) {
      hours += 12;
    }

    return hours * 60 + minutes;
  }

  function normalizeCanadianPostalCode(input) {
    if (!input || !input.value) return;

    const compact = input.value.replace(/[\s-]/g, '').toUpperCase();

    if (/^[A-Z][0-9][A-Z][0-9][A-Z][0-9]$/.test(compact)) {
      input.value = compact.slice(0, 3) + ' ' + compact.slice(3);
      return;
    }

    input.value = input.value.toUpperCase();
  }

  function normalizePhoneNumber(input) {
    if (!input || !input.value) return;

    const digits = input.value.replace(/\D/g, '');
    const localDigits = digits.length === 11 && digits.charAt(0) === '1' ? digits.slice(1) : digits;

    if (localDigits.length !== 10) return;

    input.value = localDigits.slice(0, 3) + '-' + localDigits.slice(3, 6) + '-' + localDigits.slice(6);
  }

  function normalizePhoneNumbers(root) {
    if (!root) return;

    root.querySelectorAll('[data-phone-number]').forEach(normalizePhoneNumber);
  }

  function getLocalDateString(date) {
    const year = String(date.getFullYear());
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return year + '-' + month + '-' + day;
  }

  function initializeAll(scope) {
    scope.querySelectorAll('[data-cake-request-form]').forEach(initCakeRequestForm);
  }

  function handleBlockSelect(event) {
    const root = event.target.closest('[data-cake-request-form]');
    if (!root || !event.detail || !event.detail.blockId) return;

    const control = root.querySelector('[data-cake-category-control][data-panel-id="' + event.detail.blockId + '"]');
    if (control) {
      const checkedControl = root.querySelector('[data-cake-category-control]:checked');

      if (!root.hasAttribute('data-preview-previous-cake-panel-id')) {
        root.setAttribute(
          'data-preview-previous-cake-panel-id',
          checkedControl ? checkedControl.dataset.panelId || '' : ''
        );
      }

      control.checked = true;
      setCakeCategoryState(root, { clearPrevious: false });
      return;
    }

    const select = root.querySelector('[data-cake-category]');
    if (!select) return;

    const option = Array.from(select.options).find(function (item) {
      return item.dataset.panelId === event.detail.blockId;
    });

    if (!option) return;

    if (!root.hasAttribute('data-preview-previous-cake-value')) {
      root.setAttribute('data-preview-previous-cake-value', select.value);
    }

    select.value = option.value;
    setCakeCategoryState(root, { clearPrevious: false });
  }

  function handleBlockDeselect(event) {
    const root = event.target.closest('[data-cake-request-form]');
    if (!root) return;

    if (root.hasAttribute('data-preview-previous-cake-panel-id')) {
      const previousPanelId = root.getAttribute('data-preview-previous-cake-panel-id') || '';
      const controls = root.querySelectorAll('[data-cake-category-control]');

      controls.forEach(function (control) {
        control.checked = control.dataset.panelId === previousPanelId;
      });

      root.removeAttribute('data-preview-previous-cake-panel-id');
      setCakeCategoryState(root, { clearPrevious: false });
      return;
    }

    if (!root.hasAttribute('data-preview-previous-cake-value')) return;

    const select = root.querySelector('[data-cake-category]');
    if (!select) return;

    select.value = root.getAttribute('data-preview-previous-cake-value') || '';
    root.removeAttribute('data-preview-previous-cake-value');
    setCakeCategoryState(root, { clearPrevious: false });
  }

  if (!sharedState.listenersBound) {
    sharedState.listenersBound = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll(document);
      });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:block:select', handleBlockSelect);
    document.addEventListener('shopify:block:deselect', handleBlockDeselect);
  } else {
    initializeAll(document);
  }

  window.BakerRaeCakeRequestForm = {
    initCakeRequestForm: initCakeRequestForm,
    setOccasionState: setOccasionState,
    setFulfillmentState: setFulfillmentState,
    setCakeCategoryState: setCakeCategoryState,
    syncWeddingOccasionState: syncWeddingOccasionState,
    updateProgressiveState: updateProgressiveState,
    setConditionalGroup: setConditionalGroup,
    setRequired: setRequired,
    clearControls: clearControls,
    setDateConstraints: setDateConstraints,
    validateDateOrder: validateDateOrder,
    normalizeCanadianPostalCode: normalizeCanadianPostalCode
  };
})();
